import { useState, useEffect } from "react";
import { buildTrendByWasteCategory } from "../utils/collectionChartUtils";
/**
 * Hook pour traiter les données de statistiques de collection
 */
export const useCollectionStatisticsData = (
  statisticsCollectionCurrent,
  statisticsCollectionPrevious,
  packmatPerformance,
) => {
  const [data, setData] = useState({});
  const [displayFillingByFlux, setDisplayFillingByFlux] = useState(true);
  const [displayFillingByTime, setDisplayFillingByTime] = useState(false);
  const [trendByWasteCategoryCurrent, setTrendByWasteCategoryCurrent] =
    useState([]);
  const [trendByWasteCategoryPrevious, setTrendByWasteCategoryPrevious] =
    useState([]);
  const [dataType, setDataType] = useState("flux");
  const [dataByContainer, setDataByContainer] = useState([]);

  useEffect(() => {
    if (Object.keys(statisticsCollectionCurrent).length > 0) {
      setData(statisticsCollectionCurrent.dataResult);

      const dataByWasteCategory = buildTrendByWasteCategory(
        statisticsCollectionCurrent.dataResult,
        packmatPerformance,
      );

      const byContainer = Object.keys(
        statisticsCollectionCurrent.dataByContainer,
      )
        .map((item) => {
          const { sumFillingLevel, countFillingLevel, countPackmat } =
            statisticsCollectionCurrent.dataByContainer[item];

          const packmatData =
            packmatPerformance?.packmatGainByContainer?.[item];

          if (countPackmat > 0 && packmatData && packmatData.packmatCount > 0) {
            const averageFillRate =
              countFillingLevel > 0 ? sumFillingLevel / countFillingLevel : 0;

            const averageGain = packmatData.gain / countFillingLevel;

            const performance = averageFillRate + averageGain;

            return {
              containerId: item,
              rotations: countFillingLevel,
              averageGain: Number(averageGain.toFixed(2)),
              performance: Number(performance.toFixed(2)),
              averageFillRate: Number(averageFillRate.toFixed(2)),
              factor: Number((performance / 100).toFixed(2)),
              averagePackmatRate:
                countFillingLevel > 0
                  ? Number(
                      (packmatData.packmatCount / countFillingLevel).toFixed(2),
                    )
                  : 0,
              positioning: packmatData.positioning,
              addressName: packmatData.addressName,
              wasteName: packmatData.wasteName,
            };
          }

          return null;
        })
        .filter(Boolean);

      setTrendByWasteCategoryCurrent(dataByWasteCategory);
      setDataByContainer(byContainer);
    }
  }, [statisticsCollectionCurrent, packmatPerformance]);

  useEffect(() => {
    const previousDataResult = statisticsCollectionPrevious?.dataResult ?? null;
    if (previousDataResult && Object.keys(previousDataResult).length > 0) {
      setTrendByWasteCategoryPrevious(
        buildTrendByWasteCategory(previousDataResult),
      );
    } else {
      setTrendByWasteCategoryPrevious([]);
    }
  }, [statisticsCollectionPrevious]);

  const displayData =
    dataType === "flux" ? trendByWasteCategoryCurrent : dataByContainer;

  return {
    data,
    displayFillingByFlux,
    setDisplayFillingByFlux,
    displayFillingByTime,
    setDisplayFillingByTime,
    trendByWasteCategoryCurrent,
    trendByWasteCategoryPrevious,
    dataType,
    setDataType,
    dataByContainer,
    displayData,
  };
};
